import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: string;
  tags: string[];
}

export default function VideoCard({ id, title, thumbnail, duration, views, rating, tags }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      aria-label={`观看 ${title}`}
    >
      <div className="relative overflow-hidden rounded-xl aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          title={`西瓜视频 - ${title}`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center transform scale-75 group-hover:scale-100 transition-transform duration-300">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 bg-black/75 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
          {duration}
        </span>
        <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-semibold">
          {rating}
        </span>
      </div>
      <div className="mt-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views}
          </span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}